import { Text, TouchableOpacity, View } from 'react-native'
import { Icon } from 'react-native-elements'
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '../../styles'
import listMenuItemStyles from '../../styles/listMenuItem'

export default function SimpleMenuListItem(props) {
  const {
    t, titleKey, onPress, accessibilityLabel, testID,
  } = props
  return (
    <TouchableOpacity onPress={onPress} testID={testID}>
      <View
        style={[listMenuItemStyles.simpleListItemButton, listMenuItemStyles.simpleListItemButtonSpacing, { flex: 1, flexShrink: 1 }]}
        accessibilityLabel={accessibilityLabel}
        underlayColor="#ddd"
      >
        <View style={[listMenuItemStyles.listItemTextView, {
            flex: 1,
            flexShrink: 1,
            marginRight: 16,
        }]}
        >
          <Text
            testID={`${testID}-text`}
            style={listMenuItemStyles.simpleListItemText}
          >
            {t(titleKey)}
          </Text>
        </View>
        <Icon
          name="chevron-right"
          type="material-community"
          size={24}
          color={colors.raven_grey}
          style={[listMenuItemStyles.listItemChevron, {
            flex: 1,
            flexShrink: 1,
}]}
        />
      </View>
    </TouchableOpacity>
  )
}

SimpleMenuListItem.propTypes = {
  t: PropTypes.func.isRequired,
  titleKey: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  accessibilityLabel: PropTypes.string,
  testID: PropTypes.string.isRequired,
}

SimpleMenuListItem.defaultProps = {
  accessibilityLabel: null,
}
